var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M4.233 2.117l-.37-.37-1.482 1.48V0h-.529v3.228L.37 1.746l-.37.37 2.117 2.117z"}})}
var staticRenderFns = []

export { render, staticRenderFns }